<template>
  <div class="alert" :class="`${state}`">
    <img :src="currentIcon" class="alert__icon" alt="icon" />
    <div class="alert__body">
      <div class="alert__title">{{ title }}</div>
      <div class="alert__info">{{ info }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Button',
  props: {
    title: {
      value: String,
      default: ''
    },
    info: {
      value: String,
      default: ''
    },
    state: {
      value: String,
      default: 'warning',
      validator: function(value) {
        return ['warning', 'success', 'error'].includes(value)
      }
    },
    loading: {
      value: Boolean,
      default: false
    },
    size: {
      value: String,
      default: 'lg',
      validator: function(value) {
        return ['lg', 'md', 'sm'].includes(value)
      }
    }
  },

  computed: {
    currentIcon() {
      return this.state === 'warning' ? require('@/assets/images/base/warning.svg') : ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import './alert';
</style>
